import React, { Component } from 'react';
import { Modal } from 'antd';
import DragM from '../dragm';
import './index.less';

const confirm = Modal.confirm;
const info = Modal.info;
const success = Modal.success;
const error = Modal.error;
const warning = Modal.warning;
const warn = Modal.warn;

export interface ModalTitleProps {
  uniqueness: string;
  title: string | React.ReactElement;
}

export interface ModalTitleState {
  enable: boolean;
  maxTransformX: number;
  maxTransformY: number;
    isSetDomTransform: boolean;
}

class ModalTitle extends Component<ModalTitleProps, ModalTitleState> {

  modalDom: HTMLElement | undefined = undefined;

  readonly state: ModalTitleState = {
    enable: true,
    maxTransformX: document.body.clientWidth / 2,
    maxTransformY: document.body.clientHeight / 2,
      isSetDomTransform: false,
  }

  componentDidMount() {
    this.updateMaxTransform();
  }

  componentWillUnmount() {
    if (this.modalDom) {
        this.setState({isSetDomTransform: false});
      this.modalDom.style.transform = '';
      this.modalDom = undefined;
    }
  }

  updateMaxTransform = () => {
    // 获取modal实例
    const { uniqueness } = this.props;
    const {isSetDomTransform} = this.state;
    if(isSetDomTransform) return;
    const element = document.getElementsByClassName(`ant-modal-wrap ${uniqueness}`)[0];
    this.modalDom = element as HTMLElement;
    if (this.modalDom !== null && this.modalDom !== undefined) {
      const content = element.getElementsByClassName('ant-modal-content')[0];
      if (content) {
        const { clientWidth, clientHeight } = content;
        if(clientWidth > 99999) return;
        const maxTransformX = (document.body.clientWidth - clientWidth) / 2;
        const maxTransformY = (document.body.clientHeight - clientHeight) / 2;
        this.setState({ maxTransformX, maxTransformY , isSetDomTransform:true });
      }
    }
  }

  updateTransform = (transformStr: string) => {
      this.updateMaxTransform();
    if (this.modalDom) {
      this.modalDom.style.transform = transformStr;
    }
  }

  render() {
    const { title } = this.props;
    const { maxTransformY, maxTransformX } = this.state;
    return (
      <DragM updateTransform={this.updateTransform} maxTransformX={maxTransformX} maxTransformY={maxTransformY}>
        <div className="senior-title">{title}</div>
      </DragM>
    );
  }
}


export interface SeniorModalProps {
  title: string | React.ReactElement;
  wrapClassName?: string;
  visible?: boolean;
  children?: React.ReactNode;
}

export interface SeniorModalState {
  uniqueness: string;
}

export default class SeniorModal extends Component<SeniorModalProps, SeniorModalState> {
  static confirm = confirm;
  static info = info;
  static success = success;
  static error = error;
  static warning = warning;
  static warn = warn;
  static AntdModal = Modal;

  readonly state: SeniorModalState = {
    uniqueness: `modal-${Date.now().toString()}`,
  }

  render() {
    const { children, wrapClassName = '', title: modalTitle } = this.props;
    const { uniqueness } = this.state;
    const title = <ModalTitle uniqueness={uniqueness} title={modalTitle} />
    const modalProps = { ...this.props, destroyOnClose: true }
    if (modalProps.title) modalProps.title = title;
    const modalClass = `${wrapClassName} ${uniqueness}`;
    const { visible = false } = modalProps;
    if (!visible) return null;
    return (
      //  @ts-ignore
      <Modal
        // id={uniqueness}
        {...modalProps}
        wrapClassName={modalClass}>
        {children}
      </Modal>
    );
  }
}
